import { useEffect } from 'react'
import { useAuth } from '../AuthProvider'

const SilentCallbackComponent = () => {
  const { userManager } = useAuth()

  useEffect(() => {
    userManager.signinSilentCallback().catch((error) => {
      console.error('Silent callback error:', error)
    })
  }, [userManager])

  return null
}

export default SilentCallbackComponent
